import { render, staticRenderFns } from "./CampaignSetupsOffstate.vue?vue&type=template&id=058e078a&scoped=true"
import script from "./CampaignSetupsOffstate.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsOffstate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e078a",
  null
  
)

export default component.exports